import { PaginationResponse } from "@/integration/application/interfaces/base.ts";
import { Notifications } from "@/integration/application/interfaces/notification.interface.ts";
import { createService } from "../../factory/service-factory.ts";

/**
 * Service for notification-related API calls
 * Refactored to use the service-factory for better error handling and request cancellation
 */
export default function notificationService() {
  // Create a base service for notifications endpoints
  const notificationsService = createService("/notifications");

  const pathMarkAsRead = async (id: string): Promise<void> => {
    return await notificationsService.customPatch<void>(`/mark-as-read/${id}`);
  };

  const getAllNotification = async (
    page: number = 1,
    limit: number = 8
  ): Promise<PaginationResponse<Notifications>> => {
    return await notificationsService.customGet<PaginationResponse<Notifications>>(
      `/all-platform`, { params: { page, limit } }
    );
  };

  const deleteNotificationById = async (id: string): Promise<void> => {
    return await notificationsService.delete<void>(id);
  };

  const getAllNotificationUnred = async (): Promise<Notifications[]> => {
    return await notificationsService.getAll<Notifications[]>();
  };

  return {
    getAllNotification,
    pathMarkAsRead,
    deleteNotificationById,
    getAllNotificationUnred,
  };
}
